import React from 'react';
import { PrivateRoute } from '../core';
import { SettingsContainer } from './containers/SettingsContainer';

export const routes = [
  <PrivateRoute exact path="/organizations/:id/settings" key="route--users" component={SettingsContainer} />,
];
